/**
 * @file: Short codes for the kinds, for the debug data of Compose.
 *
 * The debug data shows the order as one string of kinds, so a reader can see
 * where the same kind clusters. One letter per kind is not enough: Info and
 * Instaslide both start with I. A code is the shortest prefix of the name that
 * no other kind shares, and at least two letters. Spaces are left out first,
 * so a code never ends in one. The legend beside the string says which kind
 * each code is.
 */

/** The code of a row without a kind. */
const NO_KIND_CODE = '-'

const MIN_LENGTH = 2

const compact = name => name.replace(/\s+/g, '')

/** The shortest prefix of `name` that no other name in `names` starts with. */
function uniquePrefix (name, names) {
  const others = names.filter(other => other !== name)
  const length = Array.from({ length: name.length }, (_, i) => i + MIN_LENGTH)
    .find(n => !others.some(other => other.startsWith(name.slice(0, n))))

  return name.slice(0, length || name.length)
}

/**
 * The code of every kind, as a Map from kind to code. `kinds` may hold the
 * same kind many times and null for rows without a kind.
 */
function kindCodes (kinds) {
  const names = [...new Set(kinds.filter(kind => kind != null))]
  const compacted = names.map(compact)

  return new Map([
    [null, NO_KIND_CODE],
    ...names.map((name, i) => [name, uniquePrefix(compacted[i], compacted)])
  ])
}

export { kindCodes, NO_KIND_CODE }
